import { ChangeDetectionStrategy, Component, DestroyRef, inject, ViewEncapsulation, ChangeDetectorRef, PLATFORM_ID, Inject, afterNextRender } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingService } from '../../services/loader.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../common/interfaces/user.interface';

@Component({
  selector: 'wire-magic-link-verify',
  templateUrl: './magic-link-verify.component.html',
  styleUrls: ['./magic-link-verify.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MagicLinkVerifyComponent {

  private readonly userService = inject(UserService);
  private readonly loadingService = inject(LoadingService);
  private readonly toastr = inject(ToastrService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  public destroyRef = inject(DestroyRef);
  public cdr = inject(ChangeDetectorRef);

  public loading = true;
  public error: string | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    afterNextRender(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const hash = urlParams.get('hash');

      if (hash) {
        this.verifyMagicLink(hash);
      }
    });
  }

  verifyMagicLink(hash: string): void {
    this.userService.verifyMagicLink(hash)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: { access_token: string, user: User }) => {
          this.loading = false;
          if (response.access_token && response.user) {
            this.loadingService.show();
            setTimeout(() => this.loadingService.hide(), 3000);
            this.updateUserEvents();

            if (response.user.isProfileCompleted) {
              this.router.navigate(['/profile/details']);
            } else {
              this.router.navigate(['/profile/user/personal']);
            }
          }
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.loading = false;
          this.error = error.error?.message || 'Magic link is invalid or expired. Please request a new one.';
          this.cdr.detectChanges();
        }
      });
  }

  updateUserEvents(): void {
    this.userService.getMyGoings().subscribe();
  }
}
